import type { MouseEvent, ReactNode } from "react";
import { Tooltip } from "react-tippy";
import type { TooltipProps } from "react-tippy";
import type { IconProp } from "@fortawesome/fontawesome-svg-core";

import "react-tippy/dist/tippy.css";

import { Icon } from "./styles";

export type UpCustomerSettingsInfoProps = {
  infoText: ReactNode;
  width?: string;
  margin?: string;
  icon?: IconProp;
  iconcolor?: string;
} & Pick<TooltipProps, "trigger" | "interactive" | "position">;

const UpCustomerSettingsInfo = ({
  infoText,
  position: placement = "bottom",
  interactive,
  trigger = "click",
  width = "280px",
  margin,
  icon = "question-circle",
  iconcolor
}: UpCustomerSettingsInfoProps) => {
  /**
   * Prevent bubbling when click on tooltip icon with onMouseDown event.
   * Used to show the popover without opening the menu dropdown from react-select.
   * @param {object} event - the mousedown event is fired at an Element when a pointing device button is pressed while the pointer is inside the element.
   */
  function onMouseDown(event: MouseEvent<SVGSVGElement>) {
    event.stopPropagation();
  }

  return (
    <Tooltip
      useContext
      html={<div style={{ fontSize: "12px", textAlign: "left", width }}>{infoText}</div>}
      position={placement}
      trigger={trigger}
      arrow
      style={{ margin: margin || "-2px 0 0 2px" }}
      interactive={interactive}
    >
      <Icon color={iconcolor} icon={icon} onMouseDown={onMouseDown} />
    </Tooltip>
  );
};

export default UpCustomerSettingsInfo;
